type LineItem = {
	lineItemId: number | null | undefined;
	name: string | null;
	subItems: LineSubItem[];
	packageItems: any[];
	phantomSubItems: LineSubItem[];
	itemId: number | null;
	styleCode: string;
	systemCategoryId: number;
	upCharge: number;
	colorUpCharges: number;
	sizeUpCharge: number;
	specialCharge: number;
	description: string;
	quantity: number;
	price: number;
	dropShip: boolean;
	stockItems: boolean;
	total: string;
	default: string;
	note: string;
	sizeChart: {
		sizes: Size[];
		includeLengths: boolean;
	} | null;
	sizeSelections: SizeSelection[] | null;
	specialSizeSelections: SizeSelection[] | null;
	colorOptions: ColorOption[] | null;
	colorSelections: ColorSelection[] | null;
	freeTextSelections: TextSelection[] | null;
	lettering: {
		letterPositionId: number | null | undefined;
		description: string | null | undefined;
		text: string;
	} | null;
	packageCategoryId: number | null;
	packageCategory: any | null;
	parentItemId: number | null;
	includePrice: boolean;
	children: LineItem[] | LineSubItem[];
	subItemCategoryId: number | null;
	inventoryItemId: number | null;
	priceIncluded: boolean | null;
	type?: string;
	matchPreviousPoNumber?: string | null;
	placeholder?: string | null;
	upgradePackage?: boolean;
	uniqueId?: string;

	// Quantity override support - allows manual adjustments to auto-calculated quantities
	baseQuantity?: number | null;
	quantityOverride?: number | null;
	isManuallyOverridden?: boolean;
	extraItemsPrice?: number; // Price for the extra items added via override
	packageItemQuantity?: number | null; // Configured default quantity from parent (packages, sub-items, etc.)
};

type LineSubItem = LineItem & {
	itemData: LineItem;
	isDefault: boolean;
	priceIncluded: boolean;
	styleCode: string | null;
	braidPosition: string | null;
	placeholder?: string | null;
};

interface InventoryItem {
	inventoryItemId: number;
	systemCategoryId: number;
	styleCode: string;
	description: string;
	inactiveDate?: Date;
	isPackageItem?: boolean;
}

type Size = {
	id: number;
	name: string;
	lengths: Length[];
	isRetired: boolean;
};

type Length = {
	id: number;
	name: string;
};

type SizeSelection = {
	sizeId: number;
	lengthId: number;
	quantity: number;
};

type ColorPalette = {
	name: string;
	description: string;
	upcharge: number | null;
	colors: Color[];
};

type Color = {
	label: string;
	description: string;
	hexCode: string;
	isVisible: boolean;
	colorId: number;
	isRetired: boolean;
};

type ColorOption = {
	id: number;
	name: string;
	customText: string;
	letterPositionId: number | null | undefined;
	description: string | null | undefined;
	colorSelections: ColorSelection[];
	colorPalettes: ColorPalette[];
	matchPreviousPoNumber?: string | null;
};

type ColorSelection = {
	colorId: number;
	quantity: number;
	colorOptionId: number;
	upCharge: number | null | undefined;
};

type TextSelection = {
	id: number;
	colorOptionId: number;
	text: string;
};

export function hasValidColorSelections(lineItem: LineItem, requiresLettering: Boolean = false) {
	// const hasPreviousPo = lineItem.matchPreviousPoNumber != null;
	const colorOptionCount = lineItem.colorOptions?.length ?? 0;
	const freeTextOptionIds = lineItem.freeTextSelections?.map((fts) => fts.colorOptionId) ?? [];
	const colorSelectionCount =
		lineItem.colorSelections?.filter((c) => {
			return !freeTextOptionIds.includes(c.colorOptionId);
		})?.length ?? 0;
	const freeTextSelectionCount = lineItem.freeTextSelections?.length ?? 0;
	const letteringSatisfied =
		(requiresLettering &&
			lineItem.lettering &&
			lineItem.lettering.letterPositionId &&
			lineItem.lettering.text) ||
		!requiresLettering;

	// If match previous po is set or there are no color options, then there should be no color selections
	// if(hasPreviousPo || colorOptionCount === 0) {
	// 	return colorSelectionCount === 0;
	// }

	return colorOptionCount === colorSelectionCount + freeTextSelectionCount && letteringSatisfied;
}

export { LineItem, LineSubItem, Size, Length, SizeSelection, ColorOption, ColorSelection, InventoryItem };
